'use client';
/** @jsxImportSource @emotion/react */

import { type FC } from 'react';

import MuiSnackbar, {
  type SnackbarProps as MuiSnackbarProps,
} from '@mui/material/Snackbar';

type ExcludedMuiProps =
  | 'TransitionComponent'
  | 'transitionDuration'
  | 'TransitionProps';

type SnackbarProps = Omit<MuiSnackbarProps, ExcludedMuiProps>;

export const Snackbar: FC<SnackbarProps> = ({
  ContentProps: { sx: contentPropsSx = [], ...contentProps } = {},
  ...props
}) => {
  return (
    <MuiSnackbar
      {...props}
      ContentProps={{
        ...contentProps,
        sx: [
          ...(Array.isArray(contentPropsSx)
            ? contentPropsSx
            : [contentPropsSx]),
          {
            backgroundColor: (theme) => theme.palette.forceWhite.main,
            color: (theme) => theme.palette.text.primary,
          },
        ],
      }}
    />
  );
};

Snackbar.displayName = 'Snackbar';

export { type SnackbarProps };
